import { render, staticRenderFns } from "./IndexKlaimCCPd.vue?vue&type=template&id=93e0e70e&"
import script from "./IndexKlaimCCPd.vue?vue&type=script&lang=js&"
export * from "./IndexKlaimCCPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports